<template>
    <div
        :data-component-name="$options.name"
    >

        <div class="c-sidebar c-sidebar-mobile-overlay" data-lenis-prevent="" :class="{'is-open' : showSaveModal == true}">
            <div class="c-stepper" v-if="!showSaveModal">
                <div class="c-stepper__progress"></div>

                <div
                    class="c-stepper__step"
                    :class="{
                        'is-complete': (si < currentStep || formIsCompleted),
                        'is-current': si === currentStep && !formIsCompleted,
                        'c-stepper__sub__step': section.isSubStep,
                        'is-clickable': si < currentStep,
                    }"
                    v-for="(section, si) in sections"
                    :key="'section-'+section.id"
                    :id="'section-'+section.id"
                    @click="goToStep(si)"
                >
                    <button class="c-stepper__num" v-if="!section.isSubStep">
                        <span>{{ section.stepIndexLabel }}</span>
                    </button>
                    <button
                        class="c-stepper__sub__num"
                        :class="{'is-clickable': si < currentStep}"
                        v-else
                    >
                    </button> 
                    <div class="c-stepper__title" v-if="!section.isSubStep">
                        <span v-html="section.title"></span>
                    </div>
                    <div class="c-stepper__title" v-else>
                        <small v-html="section.title"></small>
                    </div>

                </div>
                <div class="c-stepper__progress"></div>
                <div
                    class="c-stepper__step"
                    :class="{
                        'is-current': formIsCompleted,
                    }"
                >
                    <button class="c-stepper__num">
                        <span v-if="formIsCompleted">
                            <svgIco icon="active"></svgIco>
                        </span>
                        <span v-else>
                            <svgIco icon="email"></svgIco>
                        </span>
                    </button>
                    <div class="c-stepper__title">
                        <span>{{ _t('Complété') }}</span>
                    </div>

                </div>

            </div>

            <div class="o-button-group__wrap">
                <div class="o-button-group -column" v-if="!showSaveModal">
                    <button 
                        v-if="allowRecovery === true && result.status !== 'success'"
                        class="o-button -stroke"
                        target="_self"
                        @click="$emit('show-save-modal', true)"
                    >
                        <span class="o-button__ico">
                            <svgIco icon="save" class="o-ico icon-save" />
                        </span>
                        <span class="o-button__text -icon-reverse">
                            <span class="o-button__text__elm" v-if="!showSaveModal">
                                {{ _t('Pas le temps de finir?') }}
                            </span>
                            <span class="o-button__text__elm" v-else>
                                {{ _t('Annuler') }}
                                <span class="sr-only">{{ _t('Recommencer plus tard') }}</span>
                            </span>
                        </span>
                    </button>
                    <a href="/nous-joindre" class="o-button -button-link" target="_self">
                        <span class="o-button__text">
                            <span class="o-button__text__elm">
                                {{ _t('Besoin d’assistance?') }}
                                <span class="sr-only">{{ _t('Redirection vers la page de contact') }}</span>
                            </span>
                        </span>
                    </a>
                </div>
            </div>

            <div v-if="showSaveModal === true" class="c-form-saver">
                <fieldset class="o-grid o-grid-12 o-form-styled">

                    <div class="o-grid-12 o-form__item__wrap">
                        <h3 class="o-title-3">{{ _t('Pas le temps de finir?') }}</h3>
                        <p>{{ _t('Sauvegardez le formulaire dans son état actuel et continuez plus tard. Un lien vous sera envoyé par courriel.') }}</p>
                    </div>

                    <div class="o-grid-12 o-form__item__wrap">
                        <div>
                            <label class="o-label" for="vehicule-vin">
                                {{ _t('Quelle est votre adresse courriel?') }}
                            </label>
                        </div>
                        <div class="o-form__item">
                            <input v-model="userEmail" @input="validateEmail" class="o-input" type="email" name="form-save-email" placeholder="" autocomplete="email">
                            <div class="o-form__validation">
                                <span class="o-form__validation__required">
                                    {{ _t('Ce champ est obligatoire.') }}
                                </span>
                                <span class="o-form__validation__error">
                                    {{ _t('Ce champ est invalide.') }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="o-grid-12">
                        <div class="o-button-group -column">
                            <button @click="$emit('save-for-later', {userEmail: userEmail, userPhone: userPhone})" class="o-button -stroke" target="_self" :disabled="(emailIsValid === true) ? false : 'disabled'">
                                <span class="o-button__ico">
                                    <svgIco icon="save" class="o-ico icon-save" />
                                </span>
                                <span class="o-button__text">
                                    <span class="o-button__text__elm">
                                        {{ _t('Sauvegarder le formulaire') }}
                                        <span class="sr-only">{{ _t('Sauvegarder le formulaire') }}</span>
                                    </span>
                                </span>
                            </button>
                            <button class="o-button -button-link" target="_self"
                                @click="$emit('show-save-modal', false)"
                            >
                                <span class="o-button__text">
                                    <span class="o-button__text__elm">
                                        {{ _t('Annuler') }}
                                        <span class="sr-only">{{ _t('Annuler la sauvegarde du formulaire') }}</span>
                                    </span>
                                </span>
                            </button>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'FormStepper',
        props: {
            sections:{
        		type: Array,
        		default(){ return [] },
        	},
            currentStep:{
        		type: Number,
        		default: 0,
            },
            allowRecovery:{
        		type: Boolean,
        		default: false,
            },
            showSaveModal:{
        		type: Boolean,
        		default: false,
            },
            formIsCompleted:{
        		type: Boolean,
        		default: false,
            },
            result: {
                type: Object,
                default(){ return {} },
            }
        },
        data(){
            return {
                emailIsValid: false,
                userEmail: null,
                userPhone: null,
        	}
        },
        methods: {

            goToStep(step) {
                if(step < this.currentStep){
                    this.$emit('go-to-step', step);
                }
            },

            validateEmail(e){
                const email = e.target.value;
                const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                this.emailIsValid = emailRegex.test(email);
            },

        },
    }
</script>